import React from 'react';

const LeftArrow = ({ color = '#667085', width = 36, height = 36, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M16.5533 12.7955C16.9926 12.3562 16.9926 11.6438 16.5533 11.2045C16.1139 10.7652 15.4017 10.7652 14.9623 11.2045L8.96232 17.2045C8.74264 17.4241 8.63281 17.7121 8.63281 18C8.63281 18.1525 8.66317 18.298 8.71818 18.4306C8.77308 18.5632 8.85445 18.6876 8.96232 18.7954L14.9623 24.7954C15.4017 25.2348 16.1139 25.2348 16.5533 24.7954C16.9926 24.3561 16.9926 23.6439 16.5533 23.2045L12.4738 19.125H27.0078C27.6291 19.125 28.1328 18.6213 28.1328 18C28.1328 17.3787 27.6291 16.875 27.0078 16.875H12.4738L16.5533 12.7955Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(LeftArrow);
